import client from "./client";

/**
 * API service for transaction operations.
 */
export const transactionsApi = {
  /**
   * Get all transactions with optional filters.
   * @param {Object} params - Query parameters
   * @param {string} params.fromDate - Start date (YYYY-MM-DD)
   * @param {string} params.toDate - End date (YYYY-MM-DD)
   * @param {string} params.locationId - Location ID filter
   * @param {string} params.source - Source filter (sync, manual)
   * @param {string} params.paymentType - Payment type filter (cash, card, mixed)
   * @returns {Promise<ApiResponse>}
   */
  getAll: async (params = {}) => {
    try {
    const queryParams = new URLSearchParams();
      
  if (params.fromDate) queryParams.append("fromDate", params.fromDate);
      if (params.toDate) queryParams.append("toDate", params.toDate);
      if (params.locationId) queryParams.append("locationId", params.locationId);
      if (params.source) queryParams.append("source", params.source);
      if (params.paymentType) queryParams.append("paymentType", params.paymentType);

    const query = queryParams.toString();
    const url = query ? `/transactions?${query}` : "/transactions";
      
      return await client.get(url);
    } catch (error) {
      return {
 success: false,
        message: error.message || "Failed to fetch transactions",
      };
    }
  },

  /**
   * Get a transaction by ID.
   * @param {string} id - Transaction ID
   * @returns {Promise<ApiResponse>}
   */
  getById: async (id) => {
    try {
      return await client.get(`/transactions/${id}`);
    } catch (error) {
      return {
     success: false,
        message: error.message || "Failed to fetch transaction",
      };
    }
  },

  /**
   * Create a new manual transaction.
   * @param {Object} data - Transaction data
   * @returns {Promise<ApiResponse>}
   */
  create: async (data) => {
    try {
      return await client.post("/transactions", data);
    } catch (error) {
      return {
        success: false,
        message: error.message || "Failed to create transaction",
   };
    }
  },

  /**
   * Delete a manual transaction.
   * Only manual entries that haven't been distributed can be deleted.
   * @param {string} id - Transaction ID
   * @returns {Promise<ApiResponse>}
   */
  delete: async (id) => {
    try {
      return await client.delete(`/transactions/${id}`);
    } catch (error) {
      return {
        success: false,
   message: error.message || "Failed to delete transaction",
      };
 }
  },

  /**
   * Get transaction summary statistics.
   * @param {Object} params - Query parameters
   * @returns {Promise<ApiResponse>}
   */
  getSummary: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      if (params.fromDate) queryParams.append("fromDate", params.fromDate);
      if (params.toDate) queryParams.append("toDate", params.toDate);
      if (params.locationId) queryParams.append("locationId", params.locationId);

 const query = queryParams.toString();
      const url = query ? `/transactions/summary?${query}` : "/transactions/summary";
  
      return await client.get(url);
    } catch (error) {
      return {
    success: false,
 message: error.message || "Failed to fetch transaction summary",
      };
    }
  },
};

export default transactionsApi;
